import React from 'react';

export default () => (
  <svg width="30" height="30" viewBox="-1 -1 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <rect stroke="#21304A" fill="none" width="30" height="30" rx="5" />
          <path
            d="M9.84 21.328h-1.6v-4.896L4 10h1.952l3.136 5.12L12.24 10h1.84l-4.24 6.432v4.896zm13.552-2.272h.032V10h1.584v11.328h-2l-5.984-9.248h-.032v9.248h-1.584V10h2.064l5.92 9.056z"
            fill="#000"
          />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-boolean-small.es6.js